export const checkboxStyles = {
  padding: '0',
};
